import { Hash, KeyRound, UserCircle } from 'lucide-react';

interface CorporateAccountRecapModalProps {
  designation: string;
  /** CodeEntreprise généré (clé de résolution SSO/leads). */
  codeEntreprise?: string;
  username: string;
  temporaryPassword: string;
}

/**
 * Identifiants du compte corporate généré à la création d'une plateforme.
 * Le mot de passe temporaire n'est jamais ré-affiché.
 */
export const CorporateAccountRecapModal: React.FC<CorporateAccountRecapModalProps> = ({
  designation,
  codeEntreprise,
  username,
  temporaryPassword,
}) => (
  <div className="p-8 max-w-2xl">
    <h2 className="text-xl font-semibold text-gray-900 mb-1 flex items-center gap-2">
      <UserCircle className="text-primary" size={20} />
      Compte corporate créé — {designation}
    </h2>
    <p className="text-sm text-gray-500 mb-5">
      Transmettez ces identifiants à la société : le mot de passe temporaire
      ne sera plus affiché.
    </p>

    <div className="rounded-xl border border-gray-200 divide-y divide-gray-100">
      {codeEntreprise && (
        <div className="flex items-center justify-between p-3">
          <span className="text-sm text-gray-600 flex items-center gap-1.5">
            <Hash size={14} className="text-gray-400" />
            Code entreprise
          </span>
          <code className="rounded bg-gray-100 px-3 py-1.5 text-sm font-mono select-all">
            {codeEntreprise}
          </code>
        </div>
      )}
      <div className="flex items-center justify-between p-3">
        <span className="text-sm text-gray-600">Identifiant</span>
        <code className="rounded bg-gray-100 px-3 py-1.5 text-sm font-mono select-all">
          {username}
        </code>
      </div>
      <div className="flex items-center justify-between p-3">
        <span className="text-sm text-gray-600 flex items-center gap-1.5">
          <KeyRound size={14} className="text-gray-400" />
          Mot de passe temporaire
        </span>
        <code className="rounded bg-gray-100 px-3 py-1.5 text-sm font-mono select-all">
          {temporaryPassword}
        </code>
      </div>
    </div>
  </div>
);
